import { List, Map } from "immutable";

import actionTypes from "../../../action-types";
import Section from "../../../models/state/sections/section/Section";
import { Sections } from "../../../models/state/sections/Sections";

export default function sectionsReducer(
  sections: Sections = Map<string, Section>(),
  action: Record<string, any>
) {
  switch (action.type) {
    case actionTypes.ADD_COURSE: {
      const course = action.payload.course;
      return sections.merge(flattenSections(course.sections)!);
    }

    case actionTypes.ADD_COURSE_SKELETON:
    case actionTypes.ADD_SECTIONS: {
      return sections.merge(flattenSections(action.payload.sections)!);
    }

    case actionTypes.ADD_SECTION: {
      return sections.merge(flattenSections([action.payload.section])!);
    }

    default:
      return sections;
  }
}

export function flattenSections(
  topLevelSections: Record<string, any>
): Sections | undefined {
  if (topLevelSections) {
    let sections = Map<string, Section>();

    for (const sectionId in topLevelSections) {
      sections = flattenSection(sections, topLevelSections[sectionId]);
    }

    return sections;
  }
}

function flattenSection(
  sections: Sections,
  section: Record<string, any>
): Sections {
  const {
    contents,
    contentIds,
    exerciseContentIds,
    moduleIds,
    modules,
    sections: currentSections,
    sectionIds,
    ...rest
  } = section;
  sections = sections.set(
    section.id,
    new Section({
      ...rest,
      contentIds: contentIds
        ? List(contentIds)
        : List(
            (contents || [])
              .filter((content: any) => !content.options?.exercise)
              .map((content: any) => content.id)
          ),
      exerciseContentIds: exerciseContentIds
        ? List(exerciseContentIds)
        : List(
            (contents || [])
              .filter((content: any) => content.options?.exercise)
              .map((content: any) => content.id)
          ),
      moduleIds: moduleIds
        ? List(moduleIds)
        : List(modules ? modules.map((module: any) => module.id) : []),
      sectionIds: sectionIds
        ? List(sectionIds)
        : List(
            currentSections
              ? currentSections.map((section: any) => section.id)
              : []
          )
    })
  );

  if (currentSections) {
    currentSections.forEach(
      (section: any) =>
        (sections = sections.merge(flattenSection(sections, section)))
    );
  }

  return sections;
}
